/* eslint-disable import/prefer-default-export */
import { ActionTypes } from '../../state/actions';

/**
 * @description routes the user to the proper election based on street address
 * @param {Function} dispatch function to dispatch actions
 * @param {Function} navigate function to navigate to new page
 * @param {Object} state the entire redux state
 */
export const routeUserToElections = (navigate, dispatch, state) => {
  const {
    elections: {
      elections: queriedElections,
    },
  } = state;

  // reset user seen address prompt for new address
  dispatch({ type: ActionTypes.SET_USER_SEEN_ADDRESS_PROMPT, payload: false });

  // if the queried address yielded one election, send user directly to it, otherwise send to all elections
  if (Object.keys(queriedElections).length === 1) {
    const singleElectionId = Object.keys(queriedElections)[0];
    navigate(`/elections/${singleElectionId}`);
  } else if (Object.keys(queriedElections).length > 0) {
    navigate('/elections?found=multiple');
  } else {
    navigate('/elections?found=none');
  }
};
